import React, { useEffect, useState } from 'react';

import { useTranslation } from 'react-i18next';

import { bemCssModules } from '@utils';
import { useNavigate } from '@utils/hooks';

import { useAppDispatch, userActions } from '@modules';

import VerifyCode from '@components/VerifyCode';
import LoginLayout from '@layouts/LoginLayout';

import style from './Verify2FACode.scss';

const cn = bemCssModules(style, 'Verify2FACode');

export const Verify2FACode: CustomFC = () => {
  const { t } = useTranslation();
  const [code, setCode] = useState('');
  const [error, setError] = useState('');
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const handleChangeCode = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { value } = event.target;
    setCode(value);
    if (!!error) setError('');
  };

  useEffect(() => {
    if (code.length === 6) {
      dispatch(userActions.confirmOTP({ code }))
        .unwrap()
        .then(() => {
          navigate(CONST.nav.success2fa);
        })
        .catch(err => {
          const errorMessage = err.data?.code?.[0];
          if (!!errorMessage) {
            setError(errorMessage);
          }
        });
    }
  }, [code]);

  return (
    <LoginLayout isHideLinks>
      <h1 className={cn('title')}>{t('public.2fa_code')}</h1>
      <VerifyCode
        code={code}
        targetValue=""
        codeType="2fa"
        codeLength={6}
        onChange={handleChangeCode}
        description={t('otp.description')}
        error={error}
      />
    </LoginLayout>
  );
};

export default Verify2FACode;
